var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSociety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.781,
    height: 16.361,
    viewBox: "0 0 23.781 16.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -14.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.516,24.03a2.438,2.438,0,1,1-2.44-2.44,2.442,2.442,0,0,1,2.44,2.44Z",
    transform: "translate(-2.958 -3.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.686,
    cy: 3.686,
    r: 3.686,
    transform: "translate(15.204 14.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.555,21.59a2.44,2.44,0,1,1-2.435,2.44A2.442,2.442,0,0,1,43.555,21.59Z",
    transform: "translate(-17.892 -3.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.955,35.715v1.608a.472.472,0,0,1-.309.446,14.046,14.046,0,0,1-3.115.743V36.248a4.442,4.442,0,0,0-1.151-3,3.344,3.344,0,0,0,1.232-.461C50.086,33.141,51.946,33.951,51.955,35.715Z",
    transform: "translate(-21.175 -9.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.23,35.2v2.254a.95.95,0,0,1-.627.894,20.385,20.385,0,0,1-13.774,0,.949.949,0,0,1-.628-.894V35.2c0-2.668,2.83-3.885,5.051-4.4a4.629,4.629,0,0,0,4.932,0C28.4,31.328,31.22,32.531,31.23,35.2Z",
    transform: "translate(-4.825 -8.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.575,33.251a4.47,4.47,0,0,0-1.151,3v2.264a13.958,13.958,0,0,1-3.111-.742A.472.472,0,0,1,7,37.323V35.715c0-1.764,1.874-2.573,3.344-2.925A3.381,3.381,0,0,0,11.575,33.251Z",
    transform: "translate(0 -9.434)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociety);
export default __webpack_public_path__ + "static/media/society.1bb6d6cfb62fe95dcfa57deefeb13432.svg";
export { ForwardRef as ReactComponent };